import * as React from 'react';
import { Component } from 'react';
import anime from 'animejs';
import { Container, Shadow, HeaderWrapper, Content } from './styled.js';
import { getComponents } from '../hooks/useOverrides/getComponents.js';

const defaultComponents = {
    Container: Container,
    Shadow: Shadow,
    HeaderWrapper: HeaderWrapper,
    Content: Content
};
class Sheet extends Component {
    constructor(props){
        super(props);
        const { shouldOpen =false , thresholdPercent =0.2  } = props;
        this.state = {
            open: shouldOpen,
            sheetOffset: 0,
            dragStartX: 0,
            direction: "",
            width: 0,
            thresholdPercent: thresholdPercent,
            swipeThreshold: 0,
            avgVelocity: 0,
            percentageDragged: !shouldOpen ? 1 : 0
        };
    }
    componentDidMount() {
        this.calculateSizeCallback();
        window.addEventListener("resize", this.calculateSizeCallback);
    }
    componentDidUpdate(prevProps) {
        const { shouldOpen =false  } = this.props;
        const { open  } = this.state;
        const prevShouldOpen = prevProps.shouldOpen;
        if (shouldOpen !== prevShouldOpen && shouldOpen !== open) {
            if (!open) {
                this.openSheet();
            } else {
                this.closeSheet();
            }
        }
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.calculateSizeCallback);
    }
    calculateSizeCallback = ()=>{
        const { thresholdPercent , width  } = this.state;
        const { shouldOpen =false  } = this.props;
        const newWidth = window.innerWidth;
        if (newWidth === width) {
            return;
        }
        const swipeThreshold = Math.ceil(newWidth * thresholdPercent);
        this.setState({
            width: newWidth,
            sheetOffset: !shouldOpen ? newWidth : 0,
            swipeThreshold
        });
    };
    /* istanbul ignore next */ updateSheet = (targets)=>{
        const { width  } = this.state;
        const { sheetOffset: newSheetOffset  } = targets;
        this.setState({
            sheetOffset: newSheetOffset,
            percentageDragged: newSheetOffset / width
        });
    };
    completeSheet = ()=>{
        const { onCloseSheet =()=>void 0  } = this.props;
        this.setState({
            open: false
        }, onCloseSheet);
    };
    resetSheet = ()=>{
        const { sheetOffset  } = this.state;
        const targets = {
            sheetOffset
        };
        anime({
            targets,
            sheetOffset: 0,
            duration: 400,
            round: 1,
            easing: "easeInOutQuad",
            update: this.updateSheet.bind(this, targets)
        });
    };
    /* istanbul ignore next */ closeSheet = ()=>{
        const { width , sheetOffset  } = this.state;
        const targets = {
            sheetOffset
        };
        anime({
            targets,
            sheetOffset: width,
            duration: 400,
            round: 1,
            easing: "easeInOutQuad",
            update: this.updateSheet.bind(this, targets),
            complete: this.completeSheet
        });
    };
    openSheet = ()=>{
        const { onOpenSheet =()=>void 0  } = this.props;
        this.setState({
            open: true
        }, ()=>{
            onOpenSheet();
            this.resetSheet();
        });
    };
    /* istanbul ignore next */ handleTouchStart = (event)=>{
        const { clientX  } = event.targetTouches[0];
        this.setState({
            dragStartX: clientX
        });
    };
    /* istanbul ignore next */ handleTouchMove = (event)=>{
        const { sheetOffset , dragStartX , width , swipeThreshold , avgVelocity  } = this.state;
        if (dragStartX > swipeThreshold) return;
        const newClientX = event.targetTouches[0].clientX;
        const calc = -(dragStartX - newClientX);
        const newOffset = calc > 0 ? calc : 0;
        const direction = sheetOffset > newOffset ? "left" : "right";
        const velocity = Math.abs(sheetOffset - newOffset);
        const percentage = newOffset / width;
        const percentageDragged = percentage < 1 ? percentage : 1;
        this.setState({
            direction,
            sheetOffset: newOffset,
            percentageDragged,
            avgVelocity: (avgVelocity + velocity) / 2
        });
    };
    /* istanbul ignore next */ handleTouchEnd = ()=>{
        const { percentageDragged , direction , thresholdPercent , avgVelocity  } = this.state;
        const shouldClose = direction === "right" && (percentageDragged > thresholdPercent || avgVelocity > 1);
        const { shouldOpen =false  } = this.props;
        if (shouldClose || !shouldOpen) {
            this.closeSheet();
        } else if (avgVelocity && percentageDragged) {
            this.resetSheet();
        }
        this.setState({
            dragStartX: 0,
            direction: ""
        });
    };
    render() {
        const { header , children , overrides ={}  } = this.props;
        const { percentageDragged , open , sheetOffset , width  } = this.state;
        const shadowOpacity = 0.8 - percentageDragged;
        const translateX = open ? `translateX(${sheetOffset}px)` : `translateX(${width}px)`;
        const { Shadow: { component: Shadow  } , Container: { component: Container  } , HeaderWrapper: { component: HeaderWrapper  } , Content: { component: Content  }  } = getComponents(defaultComponents, overrides);
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Shadow, {
            style: {
                opacity: shadowOpacity,
                display: open ? "initial" : "none"
            }
        }), /*#__PURE__*/ React.createElement(Container, {
            onTouchEnd: this.handleTouchEnd,
            onTouchMove: this.handleTouchMove,
            onTouchStart: this.handleTouchStart,
            style: {
                transform: translateX
            }
        }, /*#__PURE__*/ React.createElement(HeaderWrapper, {
            "data-testid": "sheet__header-wrapper"
        }, header), /*#__PURE__*/ React.createElement(Content, {
            "data-testid": "sheet__content"
        }, children)));
    }
}

export { Sheet };
